import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useInput from "../../hooks/useInput";
import baseUrl from "../../url/baseUrl";
import "./Auth_form.css";

// component tính năng đăng ký
const SignUp = () => {
  const navigate = useNavigate();
  const [signUpError, setSignUpError] = useState("");
  const [formError, setFormError] = useState(false);

  const {
    data: name,
    setData: setName,
    error: nameError,
  } = useInput((input) => input.length > 3);

  const {
    data: email,
    setData: setEmail,
    error: emailError,
  } = useInput((input) => input.length > 0 && input.includes("@"));

  const {
    data: address,
    setData: setAddress,
    error: addressError,
  } = useInput((input) => input.length > 3);

  const {
    data: phone,
    setData: setPhone,
    error: phoneError,
  } = useInput((input) => input.length > 0 && !isNaN(input));

  const handleSubmitSignup = async (e) => {
    e.preventDefault();
    if (name === "" || email === "" || address === "" || phone === "") {
      return setFormError(true);
    } else if (!nameError && !emailError && !addressError && !phoneError) {
      setFormError(false);
      const url = baseUrl + "/signup";

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            username: e.target.elements.username.value,
            email: e.target.elements.email.value,
            address: e.target.elements.address.value,
            Phone: e.target.elements.Phone.value,
          }),
        });

        if (response.status === 422) {
          throw new Error("Xác thực thất bại!");
        }

        if (response.status === 401) {
          throw new Error("Đăng ký thất bại do email đã được sử dụng.");
        }

        if (response.status !== 201) {
          throw new Error("Creating a user failed!");
        }
        const data = await response.json();

        alert(data.message);
        navigate("/login");
      } catch (err) {
        setSignUpError(err.message);
      }
    }
  };

  return (
    <div className="form_control_wrap">
      <div className="form__wrap">
        <form className="form-control" onSubmit={handleSubmitSignup}>
          <h1 className="text-success">Đăng ký</h1>
          {formError && (
            <p className="error_auth">Vui lòng điền đủ các trường!</p>
          )}
          {nameError && (
            <p className="error_auth">Tên phải nhiều hơn 3 ký tự!</p>
          )}
          {emailError && <p className="error_auth">Email Không hợp lệ!</p>}
          {addressError && <p className="error_auth">Địa chỉ Không hợp lệ!</p>}
          {phoneError && <p className="error_auth">Phone Không hợp lệ!</p>}
          {signUpError && <p className="error_auth">{signUpError}</p>}
          <div>
            <div className="form_name">
              <input
                value={name}
                name="username"
                type="text"
                placeholder="Username"
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="form_email">
              <input
                name="email"
                value={email}
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="form_address">
              <input
                name="address"
                value={address}
                type="address"
                placeholder="address"
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>

            <div className="form_Phone">
              <input
                name="Phone"
                value={phone}
                type="Phone"
                placeholder="Phone"
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>
          <div>
            <button className="fst-italic" type="submit">
              SIGNUP
            </button>
          </div>
        </form>
        <p className="pb-2 text-center mt-2">
          Login?{" "}
          <span>
            <Link to="/login">Click</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
